<app-leveltwo [pageName]="'Data Sales'">
<div class="General">
  <h3>{{'DataSales.SearchTitle'|translate}}</h3>

  <h4>{{'DataSales.GeneralSingle'|translate}}</h4>
  <!--<p>{{'DataSales.Limitedinformation'|translate}}:</p>-->

  <div class="info-bar">
    <p class="">{{'PropertySearch.AdditionalInfo' | translate}}</p>
    <p><a target="_blank" href="https://portal.assessor.lacounty.gov">{{'PropertySearch.AssessorPortal' | translate}}:</a> {{'PropertySearch.AssessorPortalDescription' | translate}}</p>
    <p><a target="_blank" href="https://maps.assessor.lacounty.gov">{{'PropertySearch.PIAS' | translate}}:</a> {{'PropertySearch.PIASDescription' | translate}}</p>
    <p><a target="_blank" href="https://propertytax.lacounty.gov">{{'PropertySearch.PropertyTaxPortal' | translate}}:</a> {{'PropertySearch.PropertyTaxPortalDescription' | translate}}</p>

  </div>

  <p [innerHTML]="'DataSales.Ifyouwould'|translate"></p>

  <h4>{{'DataSales.InformationonMulti'|translate}}</h4>
  <p>{{'DataSales.TheOfficeof'|translate}}</p>
  {{'DataSales.Phone'|translate}} | <b>(213) 974-3363</b><br>
  {{'DataSales.Days'|translate}} | {{'DataSales.Monday'|translate}}<br>
  {{'DataSales.Hours'|translate}} | 8:00 am - 5:00 pm PST<br>
  {{'DataSales.Email'|translate}} | <a href="mailto:datasales@assessor.lacounty.gov">datasales&#64;assessor.lacounty.gov</a><br><br>

  <p>{{'DataSales.Whensending'|translate}}</p>

  <h4>{{'DataSales.AvailableData'|translate}}</h4>
  <p>{{'DataSales.PleaseSelect'|translate}}</p>

  <div class="accordion">
    <accordion [isAnimated]="true">
      <accordion-group #drop>
        <div accordion-heading >
          <span class="dropdown-item clearfix">
            {{'DataSales.Labels'|translate}} <i class="mt-1 float-end" [ngClass]="!drop.isOpen ? 'fas fa-plus' : 'fas fa-minus'"></i>
          </span>
        </div>
        <p>{{'DataSales.Thisitem'|translate}}</p>
        <p>{{'DataSales.Itemsrequested'|translate}}</p>
        <ul>
          <li>{{'DataSales.Ain'|translate}}</li>
          <li>{{'DataSales.Ownername'|translate}}</li>
          <li>{{'DataSales.Ownermailing'|translate}}</li>
        </ul>

      </accordion-group>
      <!--
      <accordion-group #drop2>
        <div accordion-heading >
          <span class="dropdown-item clearfix">
            {{'DataSales.PriceList'|translate}} <i class="mt-1 float-end" [ngClass]="!drop2.isOpen ? 'fas fa-plus' : 'fas fa-minus'"></i>
          </span>
        </div>


      </accordion-group>
      -->

      <accordion-group #drop3>
        <div accordion-heading >
          <span class="dropdown-item clearfix">
            {{'DataSales.ApartmentBuilding'|translate}} <i class="mt-1 float-end" [ngClass]="!drop3.isOpen ? 'fas fa-plus' : 'fas fa-minus'"></i>
          </span>
        </div>
        <p>{{'DataSales.Thisitemresidential'|translate}}</p>
        <h5>{{'DataSales.DataFields'|translate}}</h5>
        <ul>
          <li>{{'DataSales.Owners'|translate}}</li>
          <li>{{'DataSales.Situs'|translate}}</li>
          <li>{{'DataSales.UseCode'|translate}}</li>
          <li>{{'DataSales.Reappraisal'|translate}}</li>
          <li>{{'DataSales.Homeexemption'|translate}}</li>
          <li>{{'DataSales.Numberof'|translate}}</li>
          <li>{{'DataSales.Personalpropval'|translate}}</li>
          <li>{{'DataSales.Ain'|translate}}</li>
        </ul>

      </accordion-group>

      <accordion-group #drop4>
        <div accordion-heading >
          <span class="dropdown-item clearfix">
            {{'DataSales.CrossRef'|translate}} <i class="mt-1 float-end" [ngClass]="!drop4.isOpen ? 'fas fa-plus' : 'fas fa-minus'"></i>
          </span>
        </div>
        <p>{{'DataSales.Thisitemvalues'|translate}}</p>
        <ul>
          <li>{{'DataSales.8900'|translate}}</li>
          <li>{{'DataSales.8910'|translate}}</li>
          <li>{{'DataSales.8920'|translate}}</li>
          <li>{{'DataSales.8940'|translate}}</li>
          <li>{{'DataSales.8950'|translate}}</li>

        </ul>
        <p>{{'DataSales.Thisitemavailable'|translate}}</p>
        <h5>{{'DataSales.DataFields'|translate}}</h5>
        <ul>
          <li>{{'DataSales.Crossrefpar'|translate}}</li>
          <li>{{'DataSales.Taxrate'|translate}}</li>
          <li>{{'DataSales.Regionaloff'|translate}}</li>
          <li>{{'DataSales.Commonarea'|translate}}</li>
          <li>{{'DataSales.Yearsold'|translate}}</li>
          <li>{{'DataSales.Recordingdate'|translate}}</li>
          <li>{{'DataSales.LandValue'|translate}}</li>
          <li>{{'DataSales.ImprovementValue'|translate}}</li>
          <li>{{'DataSales.GrossPersonal'|translate}}</li>
          <li>{{'DataSales.ExemptionClaim'|translate}}</li>
          <li>{{'DataSales.MobileHome'|translate}}</li>
          <li>{{'DataSales.FixtureValue'|translate}}</li>
          <li>{{'DataSales.AllExemption'|translate}}</li>
          <li>{{'DataSales.1stand2nd'|translate}}</li>
          <li>{{'DataSales.SpecialName'|translate}}</li>
          <li>{{'DataSales.Mailingand'|translate}}</li>
          <li>{{'DataSales.VeteranNumber'|translate}}</li>
          <li>{{'DataSales.Ain'|translate}}</li>
          <li>{{'DataSales.LegalDesc'|translate}}</li>
          <li>{{'DataSales.ZoneCode'|translate}}</li>
          <li>{{'DataSales.UseCode'|translate}}</li>
          <li>{{'DataSales.Effectiveyear'|translate}}</li>
          <li>{{'DataSales.Yearbuilt'|translate}}</li>
          <li>{{'DataSales.SQfoot'|translate}}</li>
        </ul>

      </accordion-group>

      <accordion-group #drop5>
        <div accordion-heading >
          <span class="dropdown-item clearfix">
            {{'DataSales.LocalRoll'|translate}} <i class="mt-1 float-end" [ngClass]="!drop5.isOpen ? 'fas fa-plus' : 'fas fa-minus'"></i>
          </span>
        </div>

        <p>{{'DataSales.Thisitemlocalroll'|translate}}</p>
        <h5>{{'DataSales.DataFields'|translate}}</h5>
        <div class="row">
          <div class="col-md">
            <ul>
              <li>{{'DataSales.1stand2nd'|translate}}</li>
              <li>{{'DataSales.Ain'|translate}}</li>
              <li>{{'DataSales.Buildingsqftmain'|translate}}</li>
              <li>{{'DataSales.Commonarea'|translate}}</li>
              <li>{{'DataSales.Effectiveyear'|translate}}</li>
              <li>{{'DataSales.ExemptionClaim'|translate}}</li>
              <li>{{'DataSales.Firstowner'|translate}}</li>
              <li>{{'DataSales.FixtureExemption'|translate}}</li>
              <li>{{'DataSales.FixtureValue'|translate}}</li>
              <li>{{'DataSales.GrossPropertyKey'|translate}}</li>
              <li>{{'DataSales.GrossPersonalPropertyValue'|translate}}</li>
              <li>{{'DataSales.GrossPersonalPropertyValue'|translate}}</li>
              <li>{{'DataSales.HomeExAmount'|translate}}</li>
              <li>{{'DataSales.ImprovementValue'|translate}}</li>
              <li>{{'DataSales.LandValue'|translate}}</li>
              <li>{{'DataSales.LegalDesc'|translate}}</li>
              <ul>
                <li>{{'DataSales.DescOfProp'|translate}}</li>
                <li>{{'DataSales.Township'|translate}}</li>
                <li>{{'DataSales.Section'|translate}}</li>
              </ul>
            </ul>
          </div>
          <div class="col-md">
            <ul>
              <li>{{'DataSales.MailingAdd'|translate}}</li>
              <li>{{'DataSales.MailingAddLast'|translate}}</li>
              <li>{{'DataSales.MailingAddKey'|translate}}</li>
              <li>{{'DataSales.MailingAddPostCode'|translate}}</li>
              <li>{{'DataSales.PersonalPropExAmount'|translate}}</li>
              <li>{{'DataSales.RealEstateExAmount'|translate}}</li>
              <li>{{'DataSales.RecordingDate'|translate}}</li>
              <li>{{'DataSales.RegOfficeIdNum'|translate}}</li>
              <li>{{'DataSales.Situs'|translate}}</li>
              <li>{{'DataSales.SitusDatelast'|translate}}</li>
              <li>{{'DataSales.SitusKey'|translate}}</li>
              <li>{{'DataSales.SitusPostalCode'|translate}}</li>
              <li>{{'DataSales.SpecialName'|translate}}</li>
              <li>{{'DataSales.Taxrate'|translate}}</li>
              <li>{{'DataSales.UseCode'|translate}}</li>
              <li>{{'DataSales.Yearbuilt'|translate}}</li>
              <li>{{'DataSales.Yearsold'|translate}}</li>
              <li>{{'DataSales.ZoneCode'|translate}}</li>
            </ul>
          </div>
        </div>



      </accordion-group>

      <accordion-group #drop5>
        <div accordion-heading >
          <span class="dropdown-item clearfix">
            {{'DataSales.ParcelChangeReport'|translate}} <i class="mt-1 float-end" [ngClass]="!drop5.isOpen ? 'fas fa-plus' : 'fas fa-minus'"></i>
          </span>
        </div>

        <p>{{'DataSales.ThisItemParcelChange'|translate}}</p>

        <p><u>{{'DataSales.HardCopyOnly'|translate}}</u></p>
        <ul>
          <li>{{'DataSales.ReportPrint'|translate}}</li>
          <li>{{'DataSales.ReprotTitle'|translate}}</li>
        </ul>
        <h5>{{'DataSales.DataFields'|translate}}</h5>
        <ul>
          <li>{{'DataSales.RecordType'|translate}}</li>
          <li>{{'DataSales.OldAIN'|translate}}</li>
          <li>{{'DataSales.OldParcelTaxRate'|translate}}</li>
          <li>{{'DataSales.ParcelChangeID'|translate}}</li>
          <li>{{'DataSales.Format'|translate}}</li>
          <li>{{'DataSales.Type'|translate}}</li>
          <li>{{'DataSales.EffectiveDate'|translate}}</li>
          <li>{{'DataSales.NewAIN'|translate}}</li>
          <li>{{'DataSales.NewParcelTaxRate'|translate}}</li>
          <li>{{'DataSales.OldStatus'|translate}}</li>
          <li>{{'DataSales.NewStatus'|translate}}</li>
          <li>{{'DataSales.UseCodeNew'|translate}}</li>
          <li>{{'DataSales.CityName'|translate}}</li>
          <li>{{'DataSales.RecordCount'|translate}}</li>

        </ul>

      </accordion-group>

      <accordion-group #drop6>
        <div accordion-heading >
          <span class="dropdown-item clearfix">
            {{'DataSales.PersonalProperty'|translate}} <i class="mt-1 float-end" [ngClass]="!drop6.isOpen ? 'fas fa-plus' : 'fas fa-minus'"></i>
          </span>
        </div>

        <p>{{'DataSales.Thisitemis'|translate}}</p>

        <h5>{{'DataSales.DataFields'|translate}}</h5>
        <p><strong>{{'DataSales.AircraftFile'|translate}}</strong></p>
        <div class="row">

          <div class="col-md">
          <ul>
            <li>{{'DataSales.AircraftIN'|translate}}</li>
            <li>{{'DataSales.RollYear'|translate}}</li>
            <li>{{'DataSales.OldParcelTaxRate'|translate}}</li>
            <li>{{'DataSales.OwnerName'|translate}}</li>
            <li>{{'DataSales.MailingAdd'|translate}}</li>
            <li>{{'DataSales.AirportProfileCode'|translate}}</li>
            <li>{{'DataSales.AirportSpaceNumber'|translate}}</li>
            <li>{{'DataSales.AirportName'|translate}}</li>
            <li>{{'DataSales.LocationAdd'|translate}}</li>
            <li>{{'DataSales.AssessedVal'|translate}}</li>
            <li>{{'DataSales.AssessedDate'|translate}}</li>
            <li>{{'DataSales.AircraftName'|translate}}</li>
            <li>{{'DataSales.TaxBillNum'|translate}}</li>

          </ul>
          </div>
          <div class="col-md">
          <ul>
            <li>{{'DataSales.BillDate'|translate}}</li>
            <li>{{'DataSales.Taxrate'|translate}}</li>
            <li>{{'DataSales.Ain'|translate}}</li>
            <li>{{'DataSales.AssessorRollCode'|translate}}</li>
            <li>{{'DataSales.ExemptionCodeDate'|translate}}</li>
            <li>{{'DataSales.ExemptiotAmt'|translate}}</li>
            <li>{{'DataSales.ManufacturerModelMake'|translate}}</li>
            <li>{{'DataSales.BodyType'|translate}}</li>
            <li>{{'DataSales.HullMat'|translate}}</li>
            <li>{{'DataSales.BodyLength'|translate}}</li>
            <li>{{'DataSales.BodyTypical'|translate}}</li>
            <li>{{'DataSales.HailingAirport'|translate}}</li>


          </ul>
          </div>
        </div>

        <p><strong>{{'DataSales.BusinessPersPropFile'|translate}}</strong></p>
        <div class="row">

          <div class="col-md">
          <ul>
            <li>{{'DataSales.CompanyID'|translate}}</li>
            <li>{{'DataSales.RecordYear'|translate}}</li>
            <li>{{'DataSales.OwnerName'|translate}}</li>
            <li>{{'DataSales.MailingAdd'|translate}}</li>
            <li>{{'DataSales.LocationCode'|translate}}</li>
            <li>{{'DataSales.LocationAdd'|translate}}</li>
            <li>{{'DataSales.AssessedVal'|translate}}</li>
            <li>{{'DataSales.AssessedDate'|translate}}</li>

          </ul>
          </div>
          <div class="col-md">
          <ul>
            <li>{{'DataSales.TaxBillNum'|translate}}</li>
            <li>{{'DataSales.BillDate'|translate}}</li>
            <li>{{'DataSales.Taxrate'|translate}}</li>
            <li>{{'DataSales.Ain'|translate}}</li>
            <li>{{'DataSales.AssessorRollCode'|translate}}</li>
            <li>{{'DataSales.ExemptionCodeDate'|translate}}</li>
            <li>{{'DataSales.ExemptiotAmt'|translate}}</li>

          </ul>
          </div>
        </div>

        <p><strong>{{'DataSales.MarineFile'|translate}}</strong></p>
        <div class="row">

          <div class="col-md">
          <ul>
            <li>{{'DataSales.VesselID'|translate}}</li>
            <li>{{'DataSales.RecordYear'|translate}}</li>
            <li>{{'DataSales.OwnerName'|translate}}</li>
            <li>{{'DataSales.MailingAdd'|translate}}</li>
            <li>{{'DataSales.MarinaProfileCode'|translate}}</li>
            <li>{{'DataSales.MarinaName'|translate}}</li>
            <li>{{'DataSales.LocationAdd'|translate}}</li>
            <li>{{'DataSales.AssessedVal'|translate}}</li>
            <li>{{'DataSales.AssessedDate'|translate}}</li>
            <li>{{'DataSales.VesselDate'|translate}}</li>
            <li>{{'DataSales.VesselName'|translate}}</li>
            <li>{{'DataSales.CertifiedStatCode'|translate}}</li>
            <li>{{'DataSales.CertifiedStateLevel'|translate}}</li>
            <li>{{'DataSales.TaxBillNum'|translate}}</li>
            <li>{{'DataSales.BillDate'|translate}}</li>

          </ul>
          </div>
          <div class="col-md">
          <ul>
            <li>{{'DataSales.TaxRateArea'|translate}}</li>
            <li>{{'DataSales.Ain'|translate}}</li>
            <li>{{'DataSales.AssessorRollCode'|translate}}</li>
            <li>{{'DataSales.ExemptionCodeDate'|translate}}</li>
            <li>{{'DataSales.ExemptiotAmt'|translate}}</li>
            <li>{{'DataSales.ManufacturerModelMake'|translate}}</li>
            <li>{{'DataSales.BodyType'|translate}}</li>
            <li>{{'DataSales.HullMat'|translate}}</li>
            <li>{{'DataSales.ManufacturerModelMake'|translate}}</li>
            <li>{{'DataSales.HullProp'|translate}}</li>
            <li>{{'DataSales.BodyType'|translate}}</li>
            <li>{{'DataSales.BodyTypical'|translate}}</li>
            <li>{{'DataSales.HailingMarina'|translate}}</li>

          </ul>
          </div>
        </div>


      </accordion-group>

      <accordion-group #drop7>
        <div accordion-heading >
          <span class="dropdown-item clearfix">
            {{'DataSales.PubliclyOwnedParcels'|translate}} <i class="mt-1 float-end" [ngClass]="!drop7.isOpen ? 'fas fa-plus' : 'fas fa-minus'"></i>
          </span>
        </div>

        <p>{{'DataSales.Thisitemcontains'|translate}}</p>

        <h5>{{'DataSales.DataFields'|translate}}</h5>
        <div class="row">
        <div class="col-md">
          <ul>
            <li>{{'DataSales.AgencyName'|translate}}</li>
            <li>{{'DataSales.AgencyAccountNum'|translate}}</li>
            <li>{{'DataSales.BriefLegalDesc'|translate}}</li>
            <li>{{'DataSales.TractNumber'|translate}}</li>
            <li>{{'DataSales.Ain'|translate}}</li>

          </ul>
        </div>
        <div class="col-md">
            <ul>
              <li>{{'DataSales.Regionaloff'|translate}}</li>
              <li>{{'DataSales.TaxRateArea'|translate}}</li>
              <li>{{'DataSales.UseCode'|translate}}</li>
              <li>{{'DataSales.LandValue'|translate}}</li>
              <li>{{'DataSales.ImprovementValue'|translate}}</li>

            </ul>
          </div>
        </div>

      </accordion-group>

      <accordion-group #drop8>
        <div accordion-heading >
          <span class="dropdown-item clearfix">
            {{'DataSales.SalesList'|translate}} <i class="mt-1 float-end" [ngClass]="!drop8.isOpen ? 'fas fa-plus' : 'fas fa-minus'"></i>
          </span>
        </div>

        <p>{{'DataSales.Thisitemlistsunverified'|translate}}</p>

        <h5>{{'DataSales.DataFields'|translate}}</h5>
        <div class="row">
        <div class="col-md">
          <ul>
            <li>{{'DataSales.Ain'|translate}}</li>
            <li>{{'DataSales.Regionaloff'|translate}}</li>
            <li>{{'DataSales.ClusterCode'|translate}}</li>
            <li>{{'DataSales.Situs'|translate}}</li>
            <li>{{'DataSales.CurrentOwner'|translate}}</li>
            <li>{{'DataSales.UseCode'|translate}}</li>
            <li>{{'DataSales.Zoning'|translate}}</li>
            <li>{{'DataSales.RecorderDocNum'|translate}}</li>

          </ul>
        </div>
        <div class="col-md">
            <ul>
              <li>{{'DataSales.TransferRecDate'|translate}}</li>
              <li>{{'DataSales.DeedType'|translate}}</li>
              <li>{{'DataSales.DocumentaryTransferType'|translate}}</li>
              <li>{{'DataSales.DocumentaryTransferTaxAmount'|translate}}</li>
              <li>{{'DataSales.RecordingDate'|translate}}</li>
              <li>{{'DataSales.BuildingData'|translate}}</li>
              <li>{{'DataSales.PriorTransfer'|translate}}</li>

            </ul>
          </div>
        </div>

      </accordion-group>

      <accordion-group #drop9>
        <div accordion-heading >
          <span class="dropdown-item clearfix">
            {{'DataSales.SecuredBasicFile'|translate}} <i class="mt-1 float-end" [ngClass]="!drop9.isOpen ? 'fas fa-plus' : 'fas fa-minus'"></i>
          </span>
        </div>

        <p>{{'DataSales.Theinfoonthe'|translate}}</p>

        <h5>{{'DataSales.DataFields'|translate}}</h5>
        <div class="row">
        <div class="col-md">
          <ul>
            <li>{{'DataSales.Ain'|translate}}</li>
            <li>{{'DataSales.TaxRateArea'|translate}}</li>
            <li>{{'DataSales.AgencyClassNum'|translate}}</li>
            <li>{{'DataSales.LandImprovValue'|translate}}</li>
            <li>{{'DataSales.Situs'|translate}}</li>
            <li>{{'DataSales.MailingAdd'|translate}}</li>
            <li>{{'DataSales.1stand2nd'|translate}}</li>
            <li>{{'DataSales.SpecialName'|translate}}</li>
            <li>{{'DataSales.TransferDate'|translate}}</li>
            <li>{{'DataSales.TaxStatusYear'|translate}}</li>
            <li>{{'DataSales.CurrentImprovementBaseYear'|translate}}</li>
            <li>{{'DataSales.ClusterCode'|translate}}</li>
            <li>{{'DataSales.ImpairmentKey'|translate}}</li>
            <li>{{'DataSales.BuildingData1'|translate}}</li>
            <li>{{'DataSales.Firstandsecond'|translate}}</li>

          </ul>
        </div>
        <div class="col-md">
            <ul>
              <li>{{'DataSales.Hazard'|translate}}</li>
              <li>{{'DataSales.ZoneUseCode'|translate}}</li>
              <li>{{'DataSales.PartialInterest'|translate}}</li>
              <li>{{'DataSales.ExemptionClaim'|translate}}</li>
              <li>{{'DataSales.PersonalPropValue'|translate}}</li>
              <li>{{'DataSales.Exemptioninfo'|translate}}</li>
              <li>{{'DataSales.MostRecent'|translate}}</li>
              <li>{{'DataSales.BuildingDataLine'|translate}}</li>
              <li>{{'DataSales.LegalDesc'|translate}}</li>
                <ul>
                  <li>{{'DataSales.DescOfProp'|translate}}</li>
                  <li>{{'DataSales.Township'|translate}}</li>
                  <li>{{'DataSales.Section'|translate}}</li>
                </ul>
              <li>{{'DataSales.CurrentLandBaseYear'|translate}}</li>
              <li>{{'DataSales.CurrentLandBaseValue'|translate}}</li>
              <li>{{'DataSales.LandReasonKey'|translate}}</li>
              <li>{{'DataSales.DocumentTransferTax'|translate}}</li>
              <li>{{'DataSales.LandlordInfo'|translate}}</li>
              <li>{{'DataSales.LastDoc'|translate}}</li>

            </ul>
          </div>
        </div>

      </accordion-group>

      <accordion-group #drop10>
        <div accordion-heading >
          <span class="dropdown-item clearfix">
            {{'DataSales.SpecialTransfer'|translate}} <i class="mt-1 float-end" [ngClass]="!drop10.isOpen ? 'fas fa-plus' : 'fas fa-minus'"></i>
          </span>
        </div>

        <p>{{'DataSales.Thisfileiscreated'|translate}}</p>

        <h5>{{'DataSales.DataFields'|translate}}</h5>
        <div class="row">
        <div class="col-md">
          <ul>
            <li>{{'DataSales.Ain'|translate}}</li>
            <li>{{'DataSales.Regionaloff'|translate}}</li>
            <li>{{'DataSales.ClusterCode'|translate}}</li>
            <li>{{'DataSales.UseCode'|translate}}</li>
            <li>{{'DataSales.BatchNum'|translate}}</li>
            <li>{{'DataSales.RecordingDate'|translate}}</li>
            <li>{{'DataSales.Yearsold'|translate}}</li>
            <li>{{'DataSales.TaxStatus'|translate}}</li>
          </ul>
        </div>
        <div class="col-md">
            <ul>
              <li>{{'DataSales.Zoning'|translate}}</li>
              <li>{{'DataSales.LegalDesc'|translate}}</li>
              <li>{{'DataSales.1st2ndName'|translate}}</li>
              <li>{{'DataSales.SpecialName'|translate}}</li>
              <li>{{'DataSales.Situs'|translate}}</li>
              <li>{{'DataSales.MailingAdd'|translate}}</li>
              <li>{{'DataSales.DocumentaryTaxInfo'|translate}}</li>
              <li>{{'DataSales.BuildingDataLine'|translate}}</li>
            </ul>
          </div>
        </div>

      </accordion-group>

            <accordion-group #drop11>
        <div accordion-heading >
          <span class="dropdown-item clearfix">
            {{'DataSales.UnsecuredAssessment'|translate}} <i class="mt-1 float-end" [ngClass]="!drop11.isOpen ? 'fas fa-plus' : 'fas fa-minus'"></i>
          </span>
        </div>

        <p>{{'DataSales.Thisfileiscreated'|translate}}</p>

        <h5>{{'DataSales.DataFields'|translate}}</h5>
        <div class="row">
        <div class="col-md">
          <ul>
            <li>{{'DataSales.1st2ndName'|translate}}</li>
            <li>{{'DataSales.CompanyNum'|translate}}</li>
            <li>{{'DataSales.Ain'|translate}}</li>
            <li>{{'DataSales.MailingandSitusAdd'|translate}}</li>
            <li>{{'DataSales.SpecialName'|translate}}</li>
            <li>{{'DataSales.Penalties'|translate}}</li>
            <li>{{'DataSales.TotalLevies'|translate}}</li>

          </ul>
        </div>
        <div class="col-md">
            <ul>
              <li>{{'DataSales.Desc'|translate}}</li>
              <li>{{'DataSales.LandValue'|translate}}</li>
              <li>{{'DataSales.ImprovementValue'|translate}}</li>
              <li>{{'DataSales.AircraftFixturePersonalProp'|translate}}</li>
              <li>{{'DataSales.Exemptioninfo'|translate}}</li>
              <li>{{'DataSales.TaxRateArea'|translate}}</li>

            </ul>
          </div>
        </div>

      </accordion-group>

    </accordion>
  </div>

</div>

</app-leveltwo>
